import classNames from 'classnames';
import { matchPath } from 'react-router';

const getCreativeClassName = (existingClassNames, pathname, path) => classNames(...existingClassNames, {
  'creative-workflow': matchPath(pathname, { path, exact: true }),
});

export default getCreativeClassName;
